import React from 'react'

interface Props {
  path: string
}

const SignIn = (props: Props) => <>Du skal logge ind for at se denne side...</>

export default SignIn
